<template>
  <div
    v-if="
      GET_ACCOUNT_DATA.id == 1 ||
        has_perm('create_apartment') ||
        has_perm('update_apartment')
    "
  >
    <div
      v-if="
        GET_ENABLE_MODULE_AND_EXTRA_INFO_DATA.extra_info_list !== undefined &&
        GET_ENABLE_MODULE_AND_EXTRA_INFO_DATA.extra_info_list.includes(
          keyCheckShowApartmentExtraInfo
        )
      "
    >
      <apartment-add-with-extra-info></apartment-add-with-extra-info>
    </div>
    <div v-else>
      <apartment-add/>
    </div>
    <lte-core-alert
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"
    ></lte-core-alert>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#1E90FF"
    ></loading>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import utils from '@/lib/utils';
import Loading from "vue-loading-overlay";
import Enum from "../../../enum/enum";
import ApartmentAdd from "./ApartmentAdd"
import ApartmentAddWithExtraInfo from "./ApartmentAddWithExtraInfo"

export default {
  components: {
    "lte-core-alert": LTECoreAlert,
    loading: Loading,
    ApartmentAdd,
    ApartmentAddWithExtraInfo
  },
  name: "ApartmentDetailTabs",
  data() {
    return {
      isLoading: false,
      keyCheckShowApartmentExtraInfo:
        Enum.defaultExtraInfoList.APARTMENT_EXTRA_INFO
    };
  },
  watch: {},
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "GET_ACCOUNT_DATA",
      "GET_ENABLE_MODULE_AND_EXTRA_INFO_DATA"
    ])
  },

  methods: {
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "GET_TOKEN_UPLOAD"
    ])
  },
  mounted() {
    this.GET_TOKEN_UPLOAD()
  }
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Apartment/ApartmentDetailTabs.vue